import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { SCHOOL } from "@/lib/constants";

export const FloatingButtons = () => {
  const wa = `https://wa.me/91${SCHOOL.phones[0]}?text=${encodeURIComponent(
    "Hello, I would like to know more about admissions at B.R.Smart Academy."
  )}`;
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      <a
        href={wa}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        className="group flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-green-500/30 transition-transform hover:scale-110 active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-7 w-7" />
      </a>
      <a
        href={`tel:${SCHOOL.phones[0]}`}
        data-testid="floating-call-btn"
        className="group flex h-14 w-14 items-center justify-center rounded-full bg-brandred text-white shadow-lg shadow-red-500/30 transition-transform hover:scale-110 active:scale-95"
        aria-label="Call Now"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
};
